<template>
  <form @submit.prevent="addLevel">
    <label>
      <span>Name</span>
      <input :disabled="toEdit" type="text" placeholder="Level 1" autofocus v-model="name">
    </label>
    <label>
      <span>Net Pay:</span>
      <input :disabled="toEdit" type="text" placeholder="Figure will be calculated from the breakdown figure" v-model="netPay">
    </label>
    <p>Values</p>
    <div>
      <div>
        <p>Compensations</p>
        <label>
          <span>Basic</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="basic">
        </label>                
        <label>
          <span>Housing</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="housing">
        </label>                
        <label>
          <span>Transportation</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="transportation">
        </label>                
        <label>
          <span>Reimbursement</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="reimbursement">
        </label>                
        <label>
          <span>Telephone</span>
        <input :disabled="toEdit" type="text" placeholder="10,000" v-model="telephone">
        </label>
      </div>
      <div>
        <p>Deductions</p>
        <label>
          <span>Tax</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="tax">
        </label>                
        <label>
          <span>Pension</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="pension">
        </label>
      </div>
      <div>
        <p>Employees Payables</p>
        <label>
          <span>Group Life</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="groupLife">
        </label>                
        <label>
          <span>NSITF</span>
          <input :disabled="toEdit" type="text" placeholder="10,000" v-model="nsitf">
        </label>
      </div>
    </div>
    <div>
      <button v-show="!toEdit" class="btn--save" type="submit">Save & Continue</button>
      <button v-show="!toEdit" class="btn--cancel" type="reset" @click.prevent="cancelAddLevel">Cancel</button>
    </div>
  </form>
</template>

<script>
import * as types from "../../../store/constant";

export default {
  name: "LevelsForm",
  props: ['level', 'edit'],
  data() {
    return {
      name: this.$props.level ? this.$props.level.name : null,
      netPay: this.$props.level ? this.$props.level.netPay : null,
      basic: this.$props.level ? this.$props.level.basic : null,
      housing: this.$props.level ? this.$props.level.housing : null,
      transportation: this.$props.level ? this.$props.level.transportation : null,
      reimbursement: this.$props.level ? this.$props.level.reimbursement : null,
      telephone: this.$props.level ? this.$props.level.telephone : null,
      tax: this.$props.level ? this.$props.level.tax : null,
      pension: this.$props.level ? this.$props.level.pension : null,
      groupLife: this.$props.level ? this.$props.level.netPay : null,
      nsitf: this.$props.level ? this.$props.level.nsitf : null,
      toEdit: this.$props.edit ? this.$props.edit : false,
      errorMsg: "",
      successMsg: ""
    }
  },
  methods: {
    addLevel() {
      const levelsFormData = {
        title: this.name,
        net_pay: +this.netPay,
        basic: +this.basic,
        housing: +this.housing,
        transportation: +this.transportation,
        reimbursement: +this.reimbursement,
        description: "",
        telephone: +this.telephone,
        tax: +this.tax,
        pension: +this.pension,
        group_life: +this.groupLife,
        nsitf: +this.nsitf,
        purpose: ""
        }

        this.$http.post(types.EMPLOYMENT_LEVEL_API, levelsFormData)
          .then(resp => {
            this.successMsg = resp.message;
          })
          .catch(err => {
            this.errorMsg = err.message;
          })        
      },
      cancelAddLevel() {

      }
    }
  }
</script>

<style lang="scss" scoped>
form {
    padding: 50px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    color: #000000;

    > label {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 40px;

      > span {
        flex: 0 0 13%;
      }
      
      > input {
        display: inline-block;
        flex: 0 0 45%;
        height: 30px;
        padding: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
      }

      > input::placeholder {
        // text-align: center;
      }
    }

    > p {
      padding-bottom: 10px;
      font-weight: bold;
    }

    > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

      > :nth-child(2) {
        margin: 0 4.5%;
      }

      > div {
        flex: 0 0 30%;
        justify-content: space-between;

        > p {
          color: #000000;
          margin-bottom: 30px;
        }

        > label {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 35px;

          > span {
            flex: 0 0 30%;
            font-size: 0.878vw;
            font-weight: bold;
          }
          
          > input {
            display: inline-block;
            flex: 0 0 45%;
            height: 30px;
            padding: 5px;
            border: 1px solid rgba(0, 0, 0, 0.2);
          }

          > input::placeholder {
            font-size: 0.878vw;
          }
        }
      }

    }

    > div {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 30px;

      > button  {
        flex: 0 0 15%; 
        height: 35px;
        border: 0;
        outline: 0; 
        border-radius: 5px;
      }

      > .btn--save {
        background-color: #5099de;
        color: #fff;
        margin-right: 20px;
        font-size: 0.878vw;
      }

      > .btn--cancel {
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.2);
        margin-left: 20px;
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.878vw;
      }   
    }
  }
</style>